import { ButtonTheme, defaultTheme } from '@medly-components/theme';

import colors from './colors';

export const button: ButtonTheme = {
    ...defaultTheme.button,
    solid: {
        textColor: {
            default: colors.darkBlue,
            hovered: colors.darkBlue,
            pressed: colors.darkBlue,
            disabled: colors.grey[500]
        },
        bgColor: {
            default: colors.coral[500],
            hovered: colors.coral[500],
            pressed: colors.coral[600],
            disabled: colors.grey[300]
        },
        hoverShadow: true
    },
    outlined: {
        textColor: {
            default: colors.coral[500],
            hovered: colors.coral[500],
            pressed: colors.coral[600],
            disabled: colors.grey[500]
        },
        borderColor: {
            default: colors.coral[500],
            hovered: colors.coral[500],
            pressed: colors.coral[600],
            disabled: colors.grey[400]
        },
        bgColor: { default: 'transparent', hovered: 'transparent', pressed: colors.coral[50], disabled: 'transparent' },
        hoverShadow: true
    },
    flat: {
        textColor: {
            default: colors.coral[500],
            hovered: colors.coral[500],
            pressed: colors.coral[600],
            disabled: colors.grey[500]
        }
    }
};
